import { keepPreviousData, useQuery, type UseQueryOptions } from '@tanstack/vue-query';
import type { Ref } from 'vue';
import type { RecordsListFetchParams, SoldRow } from '@/types';
import ApiRequest from '@/plugins/store/actions/api/ApiRequest';

const DEFAULT_OPTIONS = {
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 5, // 5 minutes
};

export const queryKeys = {
    getSoldRoot: ['sold'],
    soldWithParams: (params: Ref<RecordsListFetchParams>) => [...queryKeys.getSoldRoot, params],
};

/**
 * Every departure in the selected period and location scope, unpaged. The page derives its weekly
 * bins, facet option sets and footer totals from this one array, so there is no server-side paging
 * or filtering contract to keep in step.
 *
 * Pig type is not sent: the caller narrows `locationIds` through
 * `getSelectedSiteIdsFilteredByPigType` before handing them over.
 */
export function useSold(fetchParams: Ref<RecordsListFetchParams>, options: UseQueryOptions<SoldRow[]> = {}) {
    return useQuery<SoldRow[]>({
        queryKey: queryKeys.soldWithParams(fetchParams),
        // Request behaviour goes to the constructor; `send`'s third argument is the body.
        queryFn: () => new ApiRequest({ skipLoadingIndicator: true }).send('get', `records/sold?${fetchParams.value.period}&location_ids=${fetchParams.value.locationIds.join(',')}`),
        placeholderData: keepPreviousData,
        ...DEFAULT_OPTIONS,
        ...options,
    });
}
